import { Permission } from '../services/api/auth/types';

function keyHasPermission(key: string, permissions?: Permission[]) {
  return Boolean(permissions?.find(item => item.slug === key));
}

export default keyHasPermission;
